import axios from "axios";
import {BASIC_URL} from "../../enum";

export const geoCoding = async (street, zip, location) => {
  const token = localStorage.getItem('jwt');

  const res = await axios.post(`${BASIC_URL}/geocoding`, {
    street,
    zip,
    location
  }, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
};
